import { EActivityType, ETranscriptionStatus } from '@constants';
import { IActivity } from '@sdk/contracts';
import { Button, Flex } from 'antd';
import { useTranslation } from 'react-i18next';

import { Wrapper } from './ActivityTranscription.styles';

import { Icon } from '@/components/Icon';
import {
  useMutateTranscriptions,
  useProfile,
  useTranscriptionDetailByActivity,
  useTranscriptionPreview
} from '@/store';

type Props = {
  activity: IActivity;
};

export const ActivityTranscription: React.FC<Props> = ({ activity }) => {
  const { isWorking, generateTranscription, sendToSearchIndex } = useMutateTranscriptions();
  const { transcription } = useTranscriptionDetailByActivity(activity._id);
  const {
    roleCheck: { isManager }
  } = useProfile();

  const { t } = useTranslation('CourseTranslations');

  const { setTranscriptionId } = useTranscriptionPreview();

  if (activity.type !== EActivityType.VIDEO || !isManager) return null;

  return (
    <Flex vertical gap={16} style={{ width: '100%' }}>
      <Wrapper status={transcription?.status}>
        {transcription ? (
          <Button
            block
            size="small"
            icon={<Icon i="Translate" />}
            onClick={() => setTranscriptionId(transcription._id)}
            loading={isWorking || transcription.status === ETranscriptionStatus.PROCESSING}>
            {t(transcription.status)}
          </Button>
        ) : (
          <Button
            block
            type="primary"
            size="small"
            loading={isWorking}
            icon={<Icon i="Translate" />}
            disabled={!activity?.resource?.file}
            onClick={() => generateTranscription(activity._id)}>
            {t('GENERATE_TRANSCRIPTION')}
          </Button>
        )}
      </Wrapper>
      <Wrapper isIndexed={transcription?.isIndexed}>
        {transcription?.isIndexed ? (
          <Button
            block
            size="small"
            icon={<Icon i="CheckmarkOutline" />}
            onClick={() => setTranscriptionId(transcription._id)}
            loading={isWorking || transcription.status === ETranscriptionStatus.PROCESSING}>
            {t('INDEXED')}
          </Button>
        ) : (
          <Button
            block
            type="primary"
            size="small"
            loading={isWorking}
            icon={<Icon i="CheckmarkOutline" />}
            disabled={!activity?.resource?.file}
            onClick={() => sendToSearchIndex(activity._id)}>
            {t('SEND_TO_INDEX')}
          </Button>
        )}
      </Wrapper>
    </Flex>
  );
};
